import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import * as _ from 'lodash';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
export var inPageNavBehavior = function inPageNavBehavior() {
  Alpine.data('inPageNavBehavior', function () {
    return {
      navPlaceholder: null,
      inPageNavContainer: null,
      activeTabRef: '',
      init: function init() {
        this.setUpAnchors();
        this.updateLink();
        this.initStickyNav();
        this.updatePosition();
        this.scrollToActiveAnchor();
      },
      setUpAnchors: function setUpAnchors() {
        this.inPageNav = this.$el;

        // Add in-page nav placeholder element to prevent page jump.
        var navPlaceholder = document.createElement('div');
        navPlaceholder.classList.add('o-in-page-nav__nav-placeholder');
        this.inPageNav.parentNode.insertBefore(navPlaceholder, this.inPageNav);
        this.inPageNavContainer = this.inPageNav.querySelector('.o-in-page-nav__listing');
        this.navPlaceholder = this.inPageNav.parentNode.querySelector('.o-in-page-nav__nav-placeholder');

        // Collect all matching headers, whether they are h2 only or h2 and h3
        var inPageList = this.inPageNav.querySelector('.o-in-page-nav__listing');
        var inPageTarget = this.inPageNav.getAttribute('data-target');
        if (inPageTarget === 'h3') {
          inPageTarget = 'h2, h3';
        }
        var sections = document.querySelectorAll('.paragraph');
        sections.forEach(function (el) {
          if (el.classList.contains('paragraph--type--rich-text')) {
            var targetId;
            var targetedEl = el.querySelectorAll(inPageTarget);
            targetedEl.forEach(function (el) {
              if (el.hasAttribute('id')) {
                targetId = el.getAttribute('id');
              } else {
                targetId = _.kebabCase(el.innerText);
                el.setAttribute('id', targetId.toString());
              }
              var listEl = document.createElement('li');
              listEl.classList.add('o-in-page-nav__listing-item');
              var listElLink = document.createElement('a');
              listElLink.innerText = el.innerText;
              listElLink.setAttribute("href", '#' + targetId.toString());
              listEl.append(listElLink);
              inPageList.append(listEl);
            });
          }
        });
      },
      updateHistory: function updateHistory() {
        window.history.replaceState({}, document.title, "#".concat(this.activeTabRef));
        window.dispatchEvent(new Event('hashchange'));
      },
      updateLink: function updateLink() {
        var _this = this;
        var inPageNavLinks = document.querySelectorAll('.o-in-page-nav__listing-item a');
        inPageNavLinks.forEach(function (linkEl) {
          linkEl.addEventListener('click', function (event) {
            var _document$querySelect;
            (_document$querySelect = document.querySelector('.o-in-page-nav--active')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.classList.remove('o-in-page-nav--active');
            event.target.classList.add('o-in-page-nav--active');
            _this.activeTabRef = _.kebabCase(linkEl.innerHTML);
            _this.updateHistory();
          });
        });
      },
      initStickyNav: function initStickyNav() {
        this.inPageNav.classList.remove('o-in-page-nav--sticky');
        if (this.navPlaceholder) {
          this.navPlaceholder.style.height = 0;
          this.navPlaceholder.style.display = "none";
        }

        // Prevent fixed nav overlapping anchor element.
        if (document.body.classList.contains('toolbar-horizontal')) {
          var toolbarHeight = window.getComputedStyle(document.documentElement).getPropertyValue('--gin-toolbar-y-offset');
          var fixedNavAndToolbarHeight = parseInt(this.inPageNav.offsetHeight) + parseInt(toolbarHeight.replace('px', '')) * 2;
          document.documentElement.style.scrollPaddingTop = "".concat(fixedNavAndToolbarHeight, "px");
        } else {
          document.documentElement.style.scrollPaddingTop = "".concat(this.inPageNav.offsetHeight, "px");
        }
      },
      updatePosition: function updatePosition() {
        var _this2 = this;
        var $this = this;
        var inPageNavLinkItems = this.inPageNav.querySelectorAll('.o-in-page-nav__listing-item a');
        var inPageStickyPos = this.inPageNav.getBoundingClientRect().top + window.pageYOffset;
        var scrollPos = 0;
        window.scrollTo(window.scrollX, window.scrollY - 1);
        window.scrollTo(window.scrollX, window.scrollY + 1);
        window.addEventListener('scroll', function () {
          scrollPos = document.body.getBoundingClientRect().top;
          for (var i = 0; i < inPageNavLinkItems.length; i++) {
            var targetId = inPageNavLinkItems[i].getAttribute('href').slice(1);
            var targetElement = document.getElementById(targetId);

            // Calculate the distance from the top of the viewport
            var fromTop = targetElement.getBoundingClientRect().top;
            if (Math.abs(fromTop) < 150) {
              _this2.removeActiveLinks();
              inPageNavLinkItems[i].classList.add('o-in-page-nav--active');
              _this2.activeTabRef = _.kebabCase(inPageNavLinkItems[i].innerHTML);
              _this2.updateHistory();
              if (_this2.inPageNav.classList.contains('o-in-page-nav--sticky')) {
                if (breakpoint.isTouch) {
                  inPageNavLinkItems[i].scrollIntoView({
                    inline: 'start'
                  });
                  _this2.activeTabRef = _.kebabCase(inPageNavLinkItems[i].innerHTML);
                  _this2.updateHistory();
                } else {
                  inPageNavLinkItems[i].scrollIntoView(false);
                }
              }
            }
          }
          if (window.pageYOffset > inPageStickyPos) {
            $this.inPageNav.classList.add('o-in-page-nav--sticky');
            // iOS trick for fixed positioning
            $this.inPageNav.style.height = $this.inPageNav.offsetHeight;

            // Update placeholder height.
            if ($this.navPlaceholder) {
              $this.navPlaceholder.style.height = "".concat($this.inPageNav.offsetHeight, "px");
              $this.navPlaceholder.style.display = "";
            }
            if (document.body.classList.contains('toolbar-horizontal')) {
              $this.inPageNav.style.top = "79px";
            }
          } else {
            $this.initStickyNav();
            _this2.removeActiveLinks();
          }
        });
      },
      scrollToActiveAnchor: function scrollToActiveAnchor() {
        var activeTabHash = window.location.hash.substring(1);
        if (activeTabHash) {
          var inPageNavLinks = document.querySelectorAll(".o-in-page-nav__listing-item a");
          inPageNavLinks.forEach(function (linkEl) {
            var linkElHash = _.kebabCase(linkEl.innerHTML);
            if (activeTabHash === linkElHash) {
              linkEl.classList.add('o-in-page-nav--active');
              if (breakpoint.isTouch) {
                linkEl.scrollIntoView({
                  inline: 'start'
                });
              } else {
                linkEl.scrollIntoView(false);
              }
              var contentEl = document.getElementById(activeTabHash);
              if (contentEl) {
                contentEl.scrollIntoView();
              }
            }
          });
        }
      },
      removeActiveLinks: function removeActiveLinks() {
        var inPageNavLinkItems = this.inPageNav.querySelectorAll('.o-in-page-nav__listing-item a');
        inPageNavLinkItems.forEach(function (inPageNavLinkItem) {
          inPageNavLinkItem.classList.remove('o-in-page-nav--active');
        });
      }
    };
  });
};